import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import Button from 'src/components/button/Button';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import styles from './WatchlistButton.module.css';

//#region [Props]
type WatchlistButtonProps = {
  isWatchlisted: boolean;
  onWatchlistClick: () => void;
  className?: string;
};
//#endregion

//#region [Component]
export default function WatchlistButton(t0) {
  const $ = _c(8);
  const {
    isWatchlisted,
    onWatchlistClick,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.SWatchlistButton, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isWatchlisted) {
    t2 = <WatchlistSvg className={styles.SWatchlistSvg} selected={isWatchlisted} />;
    $[2] = isWatchlisted;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onWatchlistClick || $[5] !== t1 || $[6] !== t2) {
    t3 = <Button className={t1} text="Legg i huskelisten" icon={t2} onClick={onWatchlistClick} />;
    $[4] = onWatchlistClick;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
//#endregion